<template>
  <div class="container">
    <div @click="$emit('close')" class="close">❌</div>
    <p>
      Au fil de votre séjour, vous enchainez bien entendu les escape-games, mais vous prenez aussi énormément de plaisir
      à parcourir la ville. A la fin de votre troisième excursion, installé à la table du plus fameux "ruin bar" de la
      ville, vous vous rendez-compte que ces trois circuits vous ont donné l'envie d'aller découvrir une nouvelle
      bourgade Hongroise.
    </p>
    <p>
      C'est là-bas que vous avez LA révélation ! L'un des bâtiments vous ramène forcément à l'énigme du CEGP, et vous
      réalisez que celui-ci est même carrément au centre de votre problème. Il vous sera maintenant facile de résoudre
      l'énigme, il vous tarde d'être de retour à Paris !
    </p>
    <div class="button-wrapper">
      <p @click="$emit('next')">Rentrer à Paris avec le nom du bâtiment</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BudapestIntro",
  components: {},
};
</script>

<style scoped>
.container {
  background: rgb(220, 220, 220);
  padding: 5px 20px;
  overflow: scroll;
  position: relative;
}
.button-wrapper {
  font-family: "VT323", monospace;
  text-align: center;
  color: white;
  background: darkred;
  line-height: 30px;
}
.button-wrapper:hover {
  opacity: 0.85;
  cursor: pointer;
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.close:hover {
  cursor: pointer;
}
</style>
